import { useState } from "react";
import Button from "../../component/common/Button";
import { useNavigate } from "react-router-dom";
import { mokiApi } from "../../services/loginApi";
import logo from "../../assets/moki_logo.svg";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState({ id: "", pswd: "" });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value }));
  };

  const handleLoginSuccess = (name) => {
    navigate("./main", { state: { name } });
  };

  const handleLogin = async () => {
    try {
      const res = await mokiApi.post("/api/auth/login", {
        id: inputValue.id,
        password: inputValue.pswd,
      });
      sessionStorage.setItem("accessToken", res.data.token);
      mokiApi.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${res.data.token}`;
      if (res.status === 200) handleLoginSuccess(res.data.name);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="flex flex-col items-center w-full max-w-[80vw] h-screen mx-auto">
      <div className="flex flex-col items-center justify-center mt-[12vh]">
        <img
          src={logo}
          alt="Moki Logo"
          className="w-[100px] h-[42px] object-contain"
        />
      </div>

      <div className="w-[90%] max-w-full mt-[5vw]">
        <p className="text-[3.3vw] font-medium mb-2">아이디</p>
        <div className="w-full h-[6vh] box-border mb-[4vw]">
          <input
            name="id"
            value={inputValue.id}
            onChange={handleInputChange}
            className="w-full h-full text-lg border-b-2 border-gray-300 focus:outline-none"
          />
        </div>

        <p className="text-[3.3vw] font-medium mb-2">비밀번호</p>
        <div className="w-full h-[6vh] box-border mb-[5vw]">
          <input
            name="pswd"
            type="password"
            value={inputValue.pswd}
            onChange={handleInputChange}
            className="w-full h-full text-lg border-b-2 border-gray-300 focus:outline-none"
          />
        </div>
      </div>

      <div
        onClick={handleLogin}
        className="flex justify-center items-center w-full my-[30px] h-[36px]"
      >
        <Button
          color="blue"
          txt="로그인"
          className="w-full h-full text-[4vw]"
        />
      </div>
    </div>
  );
}
